<template>
  <div class="main">
    <baidu-map
      id="allmap"
      @ready="mapReady"
      @zoomend="zoomend"
      @dragend="dragend"
      :min-zoom="5"
      :scroll-wheel-zoom="true"
      :double-click-zoom="true"
    >
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
      <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
      <!-- 省 provice -->
      <template v-if="Na < 7 && Na >= 5 &&  proviceLable">
        <bm-label
          v-for="(marker, index) in markers"
          :key="index"
          :position="{ lng: marker.lng, lat: marker.lat }"
          :massClear="true"
          :content="marker.content"
          :labelStyle="labelcss"
          @click="jumpArea"
          :offset="{ width: -25, height: -20 }"
        />
      </template>
      <!-- 市 -->
      <template v-if="Na < 12 && Na >=7 && cityLable">
        <bm-label
          v-for="(marker, index) in markers"
          :key="index"
          :position="{ lng: marker.lng, lat: marker.lat }"
          :massClear="true"
          :content="marker.content"
          :labelStyle="labelcss2"
          @click="jumpArea"
          :offset="{ width: -25, height: -20 }"
        />
      </template>
      <!-- 区 -->
      <template v-if="Na < 14 && Na >=12 && areaLable">
        <bm-label
          v-for="(marker, index) in markers"
          :key="index"
          :position="{ lng: marker.lng, lat: marker.lat }"
          :massClear="true"
          :content="marker.content"
          :labelStyle="labelcss3"
          @click="jumpArea"
          :offset="{ width: -25, height: -20 }"
        />
      </template>
      <!-- 公司 -->
      <template v-if=" Na >=14 && streetLable">
        <bm-label
          v-for="(marker, index) in markers"
          :key="index"
          :position="{ lng: marker.lng, lat: marker.lat }"
          :massClear="true"
          :content="marker.content"
          :labelStyle="labelcss4"
          @click="goCompany(marker)"
          :offset="{ width: -25, height: -20 }"
        />
      </template>
      
    </baidu-map>
    <div class=" fixed" v-if="!log" >
      <el-card class="box-card">
        <div slot="header"  class="clearfix">
          <i class="el-icon-s-home"></i>
          <div class="header-title">青春小店{{number}}家 </div>
        </div>
        <el-input placeholder="请输入公司名称关键词进行搜索" v-model="search" class="input-with-select">
          <el-button slot="append" @click="onSearch" icon="el-icon-search"></el-button>
        </el-input>
        <div class="c-list"  @scroll="handlerScroll($event)" > 
          <div v-for="( item,index ) in commpanyList" :key="index"
            @click="goCompany(item)"
          >
            {{item.commpany}}
          </div>
        </div>
      </el-card>
    </div>
    <div class="absolute logo"  v-if="!log" >
      <img src="../assets/icon.png" alt="">
    </div>
  </div>
</template>


<script>
import json from "@/utils/data.js"
import { Toast } from 'vant';
// import {styleJson} from "@/utils/styleJson.js"
import { BmlMarkerClusterer } from "vue-baidu-map";
export default {
  name: "HelloWorld",
  components: {
    BmlMarkerClusterer,
  },
  data() {
    return {
      proviceLable: false, // 省标签
      cityLable: false, // 市标签
      areaLable: false, // 区标签
      streetLable: false, // 公司标签
      companyLable: false, // 留一个标签
      provice: '', // 省
      city:'', // 市
      area:'', // 区
      proviceList: [ ],
      cityList:[],
      areaList:[],
      show: false, // 地区弹窗
      activeNames: ['1'],
      point: "",
      markers: [
        { lng: 116.42, lat: 39.95, content: "北京市 " },
        { lng: 117.25, lat: 38.98, content: "天津市" },
        { lng: 113.65, lat: 34.8032872934206, content: "河南省" },
      ],
      labelcss: {
        width: "45px",
        height: "45px",
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        lineHeight: "15px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgb(26,152,5,.8)",
      },
      labelcss2: { // 市级
        width: "60px",
        height: "60px",
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        lineHeight: "15px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgb(26,152,5,.8)",
      },
      labelcss3: { // 市级
        width: "70px",
        height: "70px",
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        lineHeight: "15px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgb(26,152,5,.8)",
      },
      labelcss4: { // 市级
        fontSize: "10px",
        color: "#fff",
        textAligin: "center",
        alignItems: "center",
        lineHeight: "15px",
        padding:"5px",
        border: "none",
        zIndex: "999",
        backgroundColor: "rgb(26,152,5,.8)",
      },
      map: {}, // 百度地图对象
      Na: 0, // 当前地图等级
      center: {}, // 当前地图中心点
      commpanyList: [],
      number: 0, // 地区企业数量
      showSearch: false,
      search: '', // 搜索框内容
      log: false, // 纯地图模式
      index: 1,
    };
  },
  methods: {
    // 开始准备地图
    mapReady({ BMap, map }) {
      if(!this.$route.query.zoom){
        this.map = map;
        this.Na = map.Na;
        this.point = new BMap.Point(116.2, 39.56); // 初始化地图,设置中心点坐标和地图级别
        map.centerAndZoom(new BMap.Point(116.404, 39.915), 5); // 设置中心店并设置缩放级别
        this.center = this.map.getCenter()
        map.addEventListener('click', function (e) {
        //  console.log(e.point);
        });
      } else {
        this.map = map;
        this.Na = map.Na;
        map.centerAndZoom(new BMap.Point(this.$route.query.lng, this.$route.query.lat), 14); // 设置中心店并设置缩放级别
        this.center = this.map.getCenter()
      }
    },
    // 设置所有级别的lable不可见
    noshow(){
      this.proviceLable = false
      this.cityLable = false
      this.areaLable = false
      this.streetLable = false
      this.companyLable = false
    },
    // 停止拖拽地图触发
    async dragend(e) {
      if (e.target.Na >= 14){
         if(Math.abs(e.target.getCenter().lat - this.center.lat) >= 0.01|| 
        Math.abs(e.target.getCenter().lng - this.center.lng) >= 0.01 ) {
          this.noshow()
          this.center = e.target.getCenter()
          let res = await this.$api.get( `/shops/api.php?n=1&zoom=14&lat=${this.center.lat}&lng=${this.center.lng}`)
          this.markers = res.data.map(item=> {
            item.content = `
            <div>
               <span>${item.commpany}</span>
            </div>`
            return item
          })
           this.markers[0].lat = new Number(this.markers[0].lat) + 0.0005
            this.streetLable = true
          }
      }
      else if (e.target.Na >= 12){
         if(Math.abs(e.target.getCenter().lat - this.center.lat) >= 0.1|| 
        Math.abs(e.target.getCenter().lng - this.center.lng) >= 0.1 ) {
          this.noshow()
          this.center = e.target.getCenter()
          let res = await this.$api.get( `/shops/api.php?n=3&zoom=12&lat=${this.center.lat}&lng=${this.center.lng}`)
          this.markers = res.data.map(item=> {
            item.content = `
            <div style="display:flex;flex-direction:column;align-items:center;justify-content: center; width:50px;height: 100%;text-align:center">
              <span>${item.area}</span>
              <div>${item.c}家</div>
            </div>`
            return item
          })
          this.areaLable = true
          }
       
      }else if(this.Na >= 7 ) {
        if(Math.abs(e.target.getCenter().lat - this.center.lat) >= 1|| 
        Math.abs(e.target.getCenter().lng - this.center.lng) >= 1 ) {
          this.noshow()
          this.center = e.target.getCenter()
          let res = await this.$api.get( `/shops/api.php?n=10&zoom=7&lat=${this.center.lat}&lng=${this.center.lng}`)
          this.markers = res.data.map(item=> {
            item.content = `
            <div style="display:flex;flex-direction:column;align-items:center;justify-content: center; width:50px;height: 100%;text-align:center">
              <span>${item.city}</span>
              <div>${item.c}家</div>
            </div>`
            return item
          })
          this.cityLable = true
        }
        
      }
    },
    // 监听级别改变
    async zoomend(e) {
      this.Na = e.target.Na;
      this.center = this.map.getCenter()
      this.noshow()
      if (e.target.Na >= 14){
        let res = await this.$api.get( `/shops/api.php?n=1&zoom=14&lat=${this.center.lat}&lng=${this.center.lng}`)
        this.markers = res.data.map(item=> {
          item.content = `
          <div >
            <span>${item.commpany}</span>
          </div>`
          return item
        })
        setTimeout(() => {
          this.streetLable = true
        }, 0);
      } else if (e.target.Na >= 12){
        let res = await this.$api.get( `/shops/api.php?n=3&zoom=12&lat=${this.center.lat}&lng=${this.center.lng}`)
        this.markers = res.data.map(item=> {
          item.content = `
          <div style="display:flex;flex-direction:column;align-items:center;justify-content: center; width:50px;height: 100%;text-align:center">
            <span>${item.area}</span>
            <div>${item.c}家</div>
          </div>`
          return item
        })
        setTimeout(() => {
          this.areaLable = true
        }, 0);
      } else if(e.target.Na >= 7) {
        // 获取中心点
        let res = await this.$api.get( `/shops/api.php?n=10&zoom=7&lat=${this.center.lat}&lng=${this.center.lng}`)
        this.markers = res.data.map(item=> {
          item.content = `
          <div style="display:flex;flex-direction:column;align-items:center;justify-content: center; width:50px;height: 100%;text-align:center">
            <span>${item.city}</span>
            <div>${item.c}家</div>
          </div>`
          return item
        })
        setTimeout(() => {
          this.cityLable = true
        }, 0);
      } else if(e.target.Na >= 5){
        this.cityLable = false
        this.areaLable = false
        // 省区域接口
        let res = await this.$api.get('/shops/api.php?zoom=1&lat=123&lng=233')
        this.markers = res.data.map(item=> {
          item.content = `
          <div style="display: flex;flex-direction:column;align-items:center;justify-content: center;width:50px;height: 100%;text-align:center">
            <span>${item.province}</span>
            <div>${item.c}家</div>
          </div>`
          return item
        })
        
        setTimeout(() => {
          this.proviceLable = true
        }, 0);
      }
    },
    // 点击标签地图做层级跳转
    jumpArea(e) {
      let na;
      if (this.map.Na > 0 && this.map.Na < 6) {
        na = 7;
        this.Na = na
      } else if (this.map.Na >= 6 && this.map.Na < 11) {
        na = 12;
        this.Na = na
      } else if (this.map.Na >= 11 && this.map.Na <= 15) {
        na = 16;
        this.Na = na
      } 
      this.map.setZoom(na);
      this.map.setCenter(new BMap.Point(e.target.point.lng, e.target.point.lat));
    },
    // 跳转公司页
    goCompany(item) {
      if(this.log) {
        return
      }
      this.$router.push({
        name:"name" ,
        query:item
      })
    },
    // 省份查询
    selsectPre(value) {
      this.cityList =[]
      this.$api.get(`/shops/area.php?province=${value}`)
      .then(res=> {
        this.cityList = res.data.map(item=> {
          let obj ={}
          obj.value = item
          obj.label = item
          return obj
        })
      })
    },
    // 查询市区
    selectCity(value) {
      this.$api.get(`/shops/area.php?province=${this.provice}&city=${value}`)
      .then(res=> {
        this.areaList = res.data.map(item=> {
          let obj ={}
          obj.value = item
          obj.label = item
          return obj
        })
      })
    },
    // 查询公司
    searchCommpany() {
      this.commpanyList = []
      if(this.show) {
        if(!(this.provice.length ==0)) {
          this.$api.get(`/shops/find.php?province=${this.provice}&city=${this.city}&area=${this.area}`)
          .then(res => {
            this.commpanyList = res.data
            this.number = res.data.length
          })
        } else {
          Toast("省份不能为空")
        }
      } else {
        this.$api.get(`/shops/find.php?key=${this.search}`)
          .then(res => {
            this.commpanyList = res.data
            this.number = res.data.length
          })
      }
    },
    onSearch(val) {
      this.commpanyList = []
      this.searchCommpany()
    },
    onCancel() {
      this.showSearch = false
      this.search = ''
      this.commpanyList = []
      this.number = 0
    },
    handlerScroll(e){
      if(this.search) {
        return
      }      
      if (e.srcElement.scrollTop + e.srcElement.clientHeight == e.srcElement.scrollHeight ) {
        this.index++
        this.$api.get(`/shops/list.php?p=${this.index}`)
        .then(res=> {
          this.commpanyList = this.commpanyList.concat(res.data.list)
        })
      }
	  }
  },
  created() {
    this.log = this.$route.query.log
    this.$api.get('/shops/api.php?n=5&zoom=1&lat=123&lng=233')
    .then(res=> {
      res.data = this.markers
    })

    this.$api.get('/shops/list.php')
    .then(res=> {
      this.number = res.data.total
      this.commpanyList = res.data.list
    })

    this.$api.get('/shops/area.php')
    .then(res=> {
      this.proviceList = res.data.map(item=> {
        let obj ={}
        obj.value = item
        obj.label = item
        return obj
      })
    })
  },
};
</script>

<style scoped>
.main {
  font-size: 16px;
  color: #333;
}
#allmap {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.absolute {
  position: absolute;
  bottom: 30vh;
  /* width: 25px; */
  display: flex;
  flex-direction: column;
  background-color: #fff;
  right: 15px;
  border-radius: 10px;
  padding: 5px;
  align-items: center;
}
.title {
  text-align: center;
  margin: 20px;
}
.select-box {
  display: flex;
  flex-direction: column;
  margin: 10px;
}
.select-box > div {
  margin-bottom: 10px;
}
/* .show-select {
  
} */
.company-list {
  margin: 5px 15px;
}
.company-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #e7e7e7;
}
.company-item img{
  display: block;
  width: 120px;
  height: 90px;
  border: 1px solid #dcdee2;
  border-radius: 5px;
}
.company-info {
  margin-left: 10px;
}
.company-info .company-title{
  font-size: 15px;
  color: #333;
  font-weight: bold;
}
.company-info .company-add {
  font-size: 14px;
  color: #7b7b7b
}
.logo {
  bottom: 5px;
  left: 5px;
  width:70px;
  background: transparent;
}
.logo img {
  width: 60px;
}
.van-search {
  position: fixed;
  width: 100%;
  padding: 15px 15px;
  border-radius: 15px 15px 0 0;
  background: #ffffff;
}
.btn-group {
  display: flex;
  align-items: center;
}
.van-button >>> .van-button__content {
  flex-direction: column;
}
.sure {
  width: 150px;
}
.repaly  .van-button__content{
  color: #666;
} 
.btn-group >>> .van-button--default{
  border: 0px solid red ;
} 
.list {
  margin: 0 15px;
}
.main>>>.anchorBL {
  display: none;
}
.main>>>.BMap_cpyCtrl {
  display:none;
}

.fixed {
  position: absolute;
  top: 40%;
  right: 15px;
  width: 400px;
  height: 100px;
}
.el-card {
  border: none;
}
.clearfix {
  color: #ffffff;
}
.fixed >>> .el-card__header {
  background-color: #1387ff;
}
.header-title {
  display: inline-block;
  margin: 0 15px  ;
}
.c-list {
  height: 300px;
  overflow: scroll;
}
.c-list div {
  padding: 5px 10px;
}
.c-list::-webkit-scrollbar{
  display: none;
}
</style>